<template>
  <main-layout
    class="pb-4"
    small
  >
    <appointment-summary-container />
  </main-layout>
</template>

<script>

import AppointmentSummaryContainer from '@/components/Widgets/Appointments/AppointmentSummaryContainer';

export default {
  name: 'View',
  components: { AppointmentSummaryContainer },
  data() {
    return {

    };
  },
};
</script>

<style lang="css" scoped>
</style>
